// ─── PRODUCT IMAGES (language-specific) ─────────────────────
export const IMAGES = {
  de: {
    handCard: 'https://customer-assets.emergentagent.com/job_a638eaf5-87e7-49db-ab47-92900872b6eb/artifacts/go3pd79y_B2F7DC05-649B-44A4-AB12-5AED7860FC37.png',
    boxOpen: 'https://customer-assets.emergentagent.com/job_a638eaf5-87e7-49db-ab47-92900872b6eb/artifacts/gyyqugca_4F2D26DE-25AA-4B46-AE4E-3258839D31DB.png',
  },
  en: {
    handCard: 'https://customer-assets.emergentagent.com/job_a638eaf5-87e7-49db-ab47-92900872b6eb/artifacts/spdgxl1c_96EEF652-EEAF-4FAA-B47E-7D2B514E5149.png',
    boxOpen: 'https://customer-assets.emergentagent.com/job_a638eaf5-87e7-49db-ab47-92900872b6eb/artifacts/spdgxl1c_96EEF652-EEAF-4FAA-B47E-7D2B514E5149.png',
  }
};

// ─── HOMEPAGE TRANSLATIONS ──────────────────────────────────
export const home = {
  de: {
    nav: { moment: 'Der Moment', mechanism: 'Mechanismus', box: 'Die Box', options: 'Optionen', cta: 'Deck sichern' },
    hero: {
      eyebrow: 'STRATEGISCHE KULTUR-INTERVENTION',
      h1: 'Dein Team weiß längst, was schiefläuft.',
      h1i: 'Culture Cracker hilft, es auszusprechen.',
      sub: 'Eine kartenbasierte Kultur-Intervention, die Führungsteams hilft, verborgene Muster sichtbar zu machen, schwierige Gespräche zu öffnen — und Kultur in Handlung zu übersetzen.',
      cta1: 'Deck sichern — €490',
      cta2: 'Pilot anfragen',
      note: 'Kein Feelgood-Workshop. Kein weiteres Kultur-Kartendeck.',
    },
    problem: {
      eyebrow: 'DAS EIGENTLICHE PROBLEM',
      h2: 'Kultur bricht, lange bevor sie jemand',
      h2i: 'benennt.',
      sub: 'Die meisten Teams scheitern nicht, weil ihnen Werte fehlen. Sie scheitern, weil wiederkehrende Verhaltensschleifen normal werden.',
      cards: ['Kontrolle ersetzt Vertrauen', 'Harmonie versteckt Konflikt', 'Loyalität schlägt Wahrheit', 'Reibung bleibt unausgesprochen'],
    },
    cardDraw: {
      eyebrow: 'DER MOMENT',
      h2: 'Die erste Karte fragt nicht nach einer Meinung.',
      h2i: 'Sie zeigt ein Muster.',
      sub: 'Jede Culture-Cracker-Session beginnt mit einer Karte. Zieh selbst eine.',
      note: 'Nicht, um Menschen zu beschuldigen. Nicht, um Konsens zu erzwingen. Sondern um die Dynamik sichtbar zu machen, die alle spüren — und niemand benennt.',
      btnDraw: 'Karte ziehen',
      btnNext: 'Nächste Karte ziehen',
      hint: '8 von 264 als Kostprobe · Karte antippen zum Umdrehen',
    },
    mechanism: {
      eyebrow: 'DER MECHANISMUS',
      h2: 'Kein Spiel.',
      h2i: 'Ein Diagnose-Mechanismus.',
      sub: 'Karten schaffen Distanz. Die Frage ist nicht länger persönlich — Gespräche werden leichter zu beginnen, schwerer zu vermeiden und nützlicher, um danach zu handeln.',
      steps: [
        { num: '01', title: 'Ziehen', desc: 'Eine Karte deckt eine Dynamik auf, die vertraut klingt — aber unbenannt geblieben ist.' },
        { num: '02', title: 'Besprechen', desc: 'Struktur verwandelt Unbehagen in besprechbare Beobachtungen.' },
        { num: '03', title: 'Wählen', desc: 'Das Team identifiziert das Muster, das am meisten Hebelwirkung hat.' },
        { num: '04', title: 'Handeln', desc: 'Benannte Muster werden zum Ausgangspunkt für konkrete nächste Schritte.' },
      ],
    },
    box: {
      eyebrow: 'IN DER BOX',
      h2: 'Ein komplettes System für strukturierte',
      h2i: 'Kulturgespräche.',
      stats: ['264 Karten', '8 Linsen', '33 je Linse', 'A5-Playguide'],
    },
    audience: {
      builtEyebrow: 'GEBAUT FÜR',
      notEyebrow: 'NICHT FÜR JEDEN',
      notH2: 'Das ist nichts für',
      notH2i: 'jeden.',
      builtFor: [
        { title: 'Führungsteams unter Druck', desc: 'Ausrichtung wird gebraucht. Normale Kanäle funktionieren nicht mehr.' },
        { title: 'HR & People Leads mit unsichtbarer Reibung', desc: 'Etwas stimmt nicht. Exit-Interviews deuten darauf hin. Schwer direkt anzusprechen.' },
        { title: 'Gründer, die schneller skalieren als die Kultur', desc: 'Was bei 15 funktionierte, bricht bei 50. Niemand hat benannt wie.' },
        { title: 'Berater & Facilitators', desc: 'Ein Werkzeug, das Wahrheit schneller öffnet als traditionelle Workshops.' },
      ],
      notFor: [
        'Teams, die einen Feelgood-Workshop suchen.',
        'Führungskräfte, die Kultur-Vokabular ohne Konsequenzen wollen.',
        'Performative Offsites ohne Handlungsabsicht.',
        'Organisationen, die nicht hören wollen, was hochkommt.',
      ],
      notClose: 'Wenn ihr benennen wollt, was wirklich passiert — und etwas dagegen tun —, dann könnte Culture Cracker für euch sein.',
    },
    pricing: {
      eyebrow: 'OPTIONEN',
      h2: 'Wie wollt ihr',
      h2i: 'starten?',
      diy: { label: 'DO IT YOURSELF', badge: 'SOFORT STARTKLAR', price: '€490', priceNote: 'inkl. MwSt.', features: ['264 hochwertige Karten', '8 Linsen komplett', 'A5-Playguide & Facilitator-Guide', 'Premium-Box'], cta: 'Deck bestellen' },
      guided: { label: 'GEFÜHRTER WORKSHOP', price: 'Auf Anfrage', features: ['Erfahrene Moderation', 'Individuelle Vorbereitung', 'Nachbereitung & Follow-up', 'Kartenset inklusive'], cta: 'Anfrage senden' },
      enterprise: { label: 'ENTERPRISE', price: 'Individuell', features: ['Quartalsweise Check-ins', 'Individuelle Kartenentwicklung', 'Internes Facilitator-Training', 'Kultur-Metrics'], cta: 'Kontakt aufnehmen' },
    },
    pilot: {
      eyebrow: 'DER PILOT',
      h2: 'Eine Session. Echte Muster.',
      h2i: 'Klare nächste Schritte.',
      steps: [
        { num: '01', title: 'Intake', desc: 'Kurzer Call, um eure Situation zu verstehen.' },
        { num: '02', title: 'Session', desc: 'Strukturierte Session mit dem Führungsteam.' },
        { num: '03', title: 'Debrief', desc: 'Schriftliche Reflexion + nächste Schritte.' },
      ],
      formPlaceholders: { name: 'Name', company: 'Unternehmen', role: 'Rolle', teamSize: 'Teamgröße', pattern: 'Welches Muster wiederholt sich in eurem Team?', email: 'E-Mail' },
      teamSizes: ['5–10', '20–50', '100+'],
      submit: 'Für einen Pilot bewerben',
      submitting: 'Wird gesendet...',
      formNote: 'Wir prüfen jede Anfrage manuell. Nicht jedes Team ist ein Fit.',
      successH: 'Anfrage erhalten.',
      successP: 'Wir melden uns innerhalb von 48 Stunden.',
      callEyebrow: 'LIEBER ERSTMAL REDEN?',
      callH: '20-Min-Call buchen',
      callP: 'Kein Pitch. Nur ein kurzes Gespräch, ob Culture Cracker zu eurer Situation passt.',
      callCta: 'Call anfragen',
    },
    finalCta: {
      h2: 'Hört auf, über Kultur zu reden, als wäre sie',
      h2i: 'abstrakt.',
      sub: 'Macht das Muster sichtbar. Benennt es. Arbeitet an dem, was wirklich da ist.',
      cta1: 'Deck sichern — €490',
      cta2: 'Pilot anfragen',
    },
  },
  en: {
    nav: { moment: 'The Moment', mechanism: 'Mechanism', box: 'The Box', options: 'Options', cta: 'Get the Deck' },
    hero: {
      eyebrow: 'STRATEGIC CULTURE INTERVENTION',
      h1: 'Your team already knows what\'s broken.',
      h1i: 'Culture Cracker helps them say it.',
      sub: 'A card-based culture intervention that helps leadership teams surface hidden patterns, open difficult conversations — and turn culture into action.',
      cta1: 'Get the Deck — €490',
      cta2: 'Request a Pilot',
      note: 'No feelgood workshop. No another culture card game.',
    },
    problem: {
      eyebrow: 'THE REAL PROBLEM',
      h2: 'Culture breaks long before anyone',
      h2i: 'names it.',
      sub: 'Most teams don\'t fail because they lack values. They fail because recurring behavior loops become normal.',
      cards: ['Control replaces trust', 'Harmony hides conflict', 'Loyalty beats truth', 'Friction stays unspoken'],
    },
    cardDraw: {
      eyebrow: 'THE MOMENT',
      h2: 'The first card doesn\'t ask for an opinion.',
      h2i: 'It reveals a pattern.',
      sub: 'Every Culture Cracker session starts with a card. Draw one yourself.',
      note: 'Not to blame people. Not to force consensus. But to make the dynamic visible that everyone senses — and no one names.',
      btnDraw: 'Draw a card',
      btnNext: 'Draw next card',
      hint: '8 of 264 as a sample · Tap the card to flip',
    },
    mechanism: {
      eyebrow: 'THE MECHANISM',
      h2: 'Not a game.',
      h2i: 'A diagnostic mechanism.',
      sub: 'Cards create distance. The question is no longer personal — conversations become easier to start, harder to avoid, and more useful to act on.',
      steps: [
        { num: '01', title: 'Draw', desc: 'A card uncovers a dynamic that sounds familiar — but has remained unnamed.' },
        { num: '02', title: 'Discuss', desc: 'Structure turns discomfort into discussable observations.' },
        { num: '03', title: 'Choose', desc: 'The team identifies the pattern with the most leverage.' },
        { num: '04', title: 'Act', desc: 'Named patterns become the starting point for concrete next steps.' },
      ],
    },
    box: {
      eyebrow: 'IN THE BOX',
      h2: 'A complete system for structured',
      h2i: 'culture conversations.',
      stats: ['264 cards', '8 lenses', '33 per lens', 'A5 playguide'],
    },
    audience: {
      builtEyebrow: 'BUILT FOR',
      notEyebrow: 'NOT FOR EVERYONE',
      notH2: 'This isn\'t for',
      notH2i: 'everyone.',
      builtFor: [
        { title: 'Leadership teams under pressure', desc: 'Alignment is needed. Normal channels aren\'t working anymore.' },
        { title: 'HR & People Leads with invisible friction', desc: 'Something\'s off. Exit interviews hint at it. Hard to address directly.' },
        { title: 'Founders scaling faster than culture', desc: 'What worked at 15 breaks at 50. No one has named how.' },
        { title: 'Consultants & Facilitators', desc: 'A tool that opens truth faster than traditional workshops.' },
      ],
      notFor: [
        'Teams looking for a feelgood workshop.',
        'Leaders who want culture vocabulary without consequences.',
        'Performative offsites with no intent to act.',
        'Organizations that don\'t want to hear what comes up.',
      ],
      notClose: 'If you want to name what\'s really happening — and do something about it — Culture Cracker might be for you.',
    },
    pricing: {
      eyebrow: 'OPTIONS',
      h2: 'How do you want to',
      h2i: 'start?',
      diy: { label: 'DO IT YOURSELF', badge: 'READY TO GO', price: '€490', priceNote: 'incl. VAT', features: ['264 premium cards', '8 complete lenses', 'A5 playguide & facilitator guide', 'Premium box'], cta: 'Order the Deck' },
      guided: { label: 'GUIDED WORKSHOP', price: 'On request', features: ['Experienced facilitation', 'Individual preparation', 'Follow-up & debrief', 'Card set included'], cta: 'Send inquiry' },
      enterprise: { label: 'ENTERPRISE', price: 'Custom', features: ['Quarterly check-ins', 'Custom card development', 'Internal facilitator training', 'Culture metrics'], cta: 'Get in touch' },
    },
    pilot: {
      eyebrow: 'THE PILOT',
      h2: 'One session. Real patterns.',
      h2i: 'Clear next steps.',
      steps: [
        { num: '01', title: 'Intake', desc: 'Short call to understand your situation.' },
        { num: '02', title: 'Session', desc: 'Structured session with your leadership team.' },
        { num: '03', title: 'Debrief', desc: 'Written reflection + next steps.' },
      ],
      formPlaceholders: { name: 'Name', company: 'Company', role: 'Role', teamSize: 'Team size', pattern: 'What pattern keeps repeating in your team?', email: 'Email' },
      teamSizes: ['5–10', '20–50', '100+'],
      submit: 'Apply for a Pilot',
      submitting: 'Sending...',
      formNote: 'We review every request manually. Not every team is a fit.',
      successH: 'Inquiry received.',
      successP: 'We\'ll get back to you within 48 hours.',
      callEyebrow: 'PREFER TO TALK FIRST?',
      callH: 'Book a 20-min call',
      callP: 'No pitch. Just a quick conversation to see if Culture Cracker fits your situation.',
      callCta: 'Request a call',
    },
    finalCta: {
      h2: 'Stop talking about culture as if it were',
      h2i: 'abstract.',
      sub: 'Make the pattern visible. Name it. Work on what\'s actually there.',
      cta1: 'Get the Deck — €490',
      cta2: 'Request a Pilot',
    },
  },
};

// ─── PRODUCT PAGE TRANSLATIONS ──────────────────────────────
export const product = {
  de: {
    nav: { back: 'Startseite', cta: 'Deck sichern — €490' },
    hero: {
      eyebrow: 'DAS WERKZEUG',
      h1: '264 Karten. 8 Perspektiven.',
      h1i: 'Eine Box.',
      sub: 'Ein physisches Interventionssystem für Führungsteams. Intern einsetzbar oder mit einem Moderator. Das Deck funktioniert beides.',
      cta1: 'Deck sichern — €490',
      cta2: 'Geführten Workshop buchen',
      note: 'Versand innerhalb von 5 Werktagen · DACH-Region',
    },
    lenses: {
      eyebrow: 'WAS DRIN IST',
      h2: 'Acht Perspektiven, um eine Kultur',
      h2i: 'aufzubrechen.',
      sub: 'Jedes Deck enthält 33 Karten, die entwickelt wurden, um spezifische Dynamiken sichtbar zu machen. Zusammen bilden sie ein vollständiges diagnostisches System.',
    },
    detail: {
      eyebrow: 'WIE ES FUNKTIONIERT',
      h2: 'Karten schaffen Distanz für',
      h2i: 'ehrliche Gespräche.',
      sub: 'Menschen können auf ein Muster zeigen, ohne auf eine Person zu zeigen. Die Struktur entfernt emotionale Ladung und verwandelt Anschuldigungen in gemeinsame Diagnose.',
      features: ['Physische Karten reduzieren Abwehr', 'Gemeinsame Sprache ersetzt Schuldzuweisung', 'Versteckte Muster werden benennbar', 'Teams bewegen sich von Symptomen zu Ursachen'],
    },
    buy: {
      h2: 'Bereit, eure Kultur',
      h2i: 'aufzubrechen?',
      p1: 'Culture Cracker ist ein eigenständiges diagnostisches Werkzeug. Bestellt das Deck und beginnt, an dem zu arbeiten, was in eurer Kultur wirklich passiert.',
      p2: 'Braucht ihr Moderationsunterstützung? Geführte Workshops sind separat buchbar.',
      cta1: 'Deck bestellen — €490',
      cta2: 'Geführten Workshop buchen',
      note: '€490 INKL. MWST. · VERSAND INNERHALB VON 5 WERKTAGEN',
    },
  },
  en: {
    nav: { back: 'Home', cta: 'Get the Deck — €490' },
    hero: {
      eyebrow: 'THE TOOL',
      h1: '264 cards. 8 perspectives.',
      h1i: 'One box.',
      sub: 'A physical intervention system for leadership teams. Use it internally or with a facilitator. The deck works either way.',
      cta1: 'Get the Deck — €490',
      cta2: 'Book a Guided Workshop',
      note: 'Ships within 5 business days · DACH region',
    },
    lenses: {
      eyebrow: 'WHAT\'S INSIDE',
      h2: 'Eight perspectives to crack a culture',
      h2i: 'wide open.',
      sub: 'Each deck contains 33 cards designed to surface specific dynamics. Together they form a complete diagnostic system.',
    },
    detail: {
      eyebrow: 'HOW IT WORKS',
      h2: 'Cards create distance for',
      h2i: 'honest conversations.',
      sub: 'People can point to a pattern without pointing at a person. Structure removes emotional charge and turns accusations into shared diagnosis.',
      features: ['Physical cards reduce defensiveness', 'Shared language replaces blame', 'Hidden patterns become nameable', 'Teams move from symptoms to causes'],
    },
    buy: {
      h2: 'Ready to crack your culture',
      h2i: 'open?',
      p1: 'Culture Cracker is a standalone diagnostic tool. Order the deck and start working on what\'s actually happening in your culture.',
      p2: 'Need facilitation support? Guided workshops are available separately.',
      cta1: 'Order the Deck — €490',
      cta2: 'Book a Guided Workshop',
      note: '€490 INCL. VAT · SHIPS WITHIN 5 BUSINESS DAYS',
    },
  },
};

// ─── LENS DATA (language-specific names) ────────────────────
export const lensData = {
  de: [
    { name: 'Kulturfallen', subtitle: 'Herausforderungen & Schwächen', desc: 'Deckt wiederkehrende Dysfunktionen und versteckte Muster auf, die Teams blockieren.' },
    { name: 'Exploration', subtitle: 'Ursachen & Muster', desc: 'Öffnet, was unausgesprochen bleibt, und hilft, Grundursachen zu identifizieren.' },
    { name: 'Brainstorm', subtitle: 'Ideen & Möglichkeiten', desc: 'Schafft neue Reaktionsmöglichkeiten und alternative Ansätze.' },
    { name: 'Veränderung', subtitle: 'Maßnahmen & Fortschritt', desc: 'Zeigt Widerstand, Bereitschaft und Wege nach vorne.' },
    { name: 'Schritt-für-Schritt', subtitle: 'Planung & Umsetzung', desc: 'Verwandelt Diagnose in konkrete Interventionsschritte.' },
    { name: 'Erfolgsstories', subtitle: 'Beispiele & Inspiration', desc: 'Identifiziert, was Fortschritt in der Vergangenheit wiederholbar machte.' },
    { name: 'Lighthouse', subtitle: 'Vision & Richtung', desc: 'Klärt Richtung und Prioritäten bei Unsicherheit.' },
    { name: 'Stolpersteine', subtitle: 'Risiken & Barrieren', desc: 'Benennt Hindernisse, bevor sie Fortschritt entgleisen lassen.' },
  ],
  en: [
    { name: 'Culture Traps', subtitle: 'Challenges & Pitfalls', desc: 'Uncovers recurring dysfunctions and hidden patterns that block teams.' },
    { name: 'Exploration', subtitle: 'Causes & Patterns', desc: 'Opens what stays unspoken and helps identify root causes.' },
    { name: 'Brainstorm', subtitle: 'Ideas & Possibilities', desc: 'Creates new response options and alternative approaches.' },
    { name: 'Change', subtitle: 'Actions & Progress', desc: 'Surfaces resistance, readiness, and pathways forward.' },
    { name: 'Step-by-Step', subtitle: 'Planning & Execution', desc: 'Turns diagnosis into concrete intervention steps.' },
    { name: 'Success Stories', subtitle: 'Examples & Inspiration', desc: 'Identifies what made past progress repeatable.' },
    { name: 'Lighthouse', subtitle: 'Focus & Guidance', desc: 'Clarifies direction and priorities during uncertainty.' },
    { name: 'Stumbling Blocks', subtitle: 'Risks & Barriers', desc: 'Names obstacles before they derail progress.' },
  ],
};

export const LENS_COLORS = ['#d81e74', '#1f8a4c', '#e8401f', '#5b2fd6', '#1f5fd8', '#0f6b52', '#e8a31f', '#26262a'];
